<template>
    <div class="flow-step-item" v-on:click="handleStepItemSelect" :class="{'flow-step-item--selected' : item.Selected, 'flow-step-item--dummy' : item.Dummy}">
        <img class="flow-step-item__icon" :src="item.IconUrl" alt="" />
        <p class="flow-step-item__text" v-html="item.Text"></p>
        <button class="flow__button" v-if="!item.UserSuppliesValue && !item.Dummy" v-on:click="handleStepSelect" type="button">{{dictionary.FlowStepItemButtonText}}</button>
        <input class="flow__checkbox checkbox" type="radio" name="item" :checked="item.Selected" v-if="!item.UserSuppliesValue && !item.Dummy" v-on:click="handleStepSelect" />
        <div class="flow-step-item__value-editor" v-if="item.UserSuppliesValue && !item.Dummy">
            <button type="button" v-on:click="handleStepValueChange(-1)">-</button>
            <input type="number" min="0" v-on:click="selectInputText($event)" v-on:change="handleStepValueChange($event.target.value,true)" v-model="item.Value" />
            <button type="button" v-on:click="handleStepValueChange(1)">+</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "flowStepItem",
        data() {
            return {
                value: 0
            }
        },
        props: ["item", "stepId", "dictionary", "allowSelectingMultipleItems"],
        mounted() {
            this.value = this.item.Value;
        },
        methods: {
            selectInputText(e) {
                e.target.select();
            },
            handleStepSelect() {
                this.$emit('stepValueChange', this.stepId, this.item.Id, this.item.Value, this.item.NextStepId);
            },
            handleStepItemSelect() {
                const isSmallScreen = window.matchMedia('(max-width: 768px)');
                if (isSmallScreen.matches && !this.item.UserSuppliesValue && !this.item.Dummy) {
                    this.handleStepSelect();
                }
            },
            handleStepValueChange(value, set = false) {
                value = parseInt(value);
                if (isNaN(value)) value = 0;
                if (set == true) {
                    this.value = value;
                } else {
                    if (this.value == 0 && value == -1) {
                        this.value = 0;
                    } else {
                        this.value = this.value + value;
                    }
                }
                this.$emit('stepValueChange', this.stepId, this.item.Id, this.value, this.item.NextStepId);
            }
        }
    };
</script>
